export default {
    afterInit: function(component){
        var questions = component.survey.questions;
        for(let q=0; q<questions.length; q++){
            var question = questions[q];

            switch(question.config.id){
                case 26:
                    if(question.config.type=='Percentage'){
                        question.actions = function(question, questionMap, language){
                            var enableColumns = {};
                            for(let group_id in question.value){
                                var column_answers = question.value[group_id];
                                if(!enableColumns[group_id]){
                                    enableColumns[group_id] = {}
                                }
                                for(let column_id in column_answers){
                                    if(!enableColumns[group_id][column_id]){
                                        enableColumns[group_id][column_id] = false;
                                    }
                                    var value = column_answers[column_id];
                                    if(value!=null && parseInt(value,10)>0){
                                        enableColumns[group_id][column_id] = true;
                                    }
                                }
                            }

                            var target = questionMap[27];
                            if(target.config.type=='SelectTable'){
                                for(let group_index=0; group_index<target.config.groups.length; group_index++){
                                    var group = target.config.groups[group_index];
                                    var columns = group.type_config['SelectTable'].items;

                                    for(let i=0; i<columns.length; i++){
                                        var column = columns[i];
                                        column.enabled = enableColumns[group.id][column.id];
                                    }
                                }
                                target.controller.value_action();
                                target.controller.validate();
                            }else{
                                console.error('Expected SelectTable',target);
                            }

                        }
                    }else{
                        console.error('Expected Percentage',question);
                    }
                break;             
            }
        }
    }
}